// extracted by mini-css-extract-plugin
export var paginationWrapper = "posts-module--paginationWrapper--1mNOE";
export var currentPageNumber = "posts-module--currentPageNumber--1xjwA";
export var paginationNumber = "posts-module--paginationNumber--1hKgG";
export var nextPageClassName = "posts-module--nextPageClassName--XRGyK";
export var nextPrev = "posts-module--nextPrev--s6CC8";
export var disabledButton = "posts-module--disabledButton--1zQgz";